import { render, staticRenderFns } from "./LedUpdata.vue?vue&type=template&id=4b9ebccc&scoped=true"
import script from "./LedUpdata.vue?vue&type=script&lang=js"
export * from "./LedUpdata.vue?vue&type=script&lang=js"
import style0 from "./LedUpdata.vue?vue&type=style&index=0&id=4b9ebccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9ebccc",
  null
  
)

export default component.exports